<template>
  <div class="profile-page">
    <div class="profile-container" v-loading="loading">
      <div v-if="userProfile" class="profile-content">
        <div class="profile-header">
          <div class="profile-avatar">
            <el-avatar :size="120" :src="userProfile.avatar || 'https://example.com/default-avatar.jpg'" />
          </div>
          <div class="profile-basic-info">
            <h1>{{ userProfile.nickname || userProfile.username }}</h1>
            <div class="profile-tags">
              <el-tag size="small" type="success" v-if="userAge">{{ userAge }}岁</el-tag>
              <el-tag size="small" type="warning">{{ userProfile.sex === 'male' ? '男' : '女' }}</el-tag>
              <el-tag size="small" type="info">{{ userProfile.height }}cm</el-tag>
            </div>
            <div class="profile-location">
              <el-icon><Location /></el-icon>
              <span>{{ userProfile.location || '未知' }}</span>
            </div>
             
          </div>
          <!-- <div class="profile-main-photo" v-if="userProfile.photo">
            <el-image 
              :src="userProfile.photo"
              fit="cover"
              class="main-photo"
              :preview-src-list="[userProfile.photo]"
            >
              <template #error>
                <div class="image-placeholder">
                  <el-icon><Picture /></el-icon>
                </div>
              </template>
            </el-image>
          </div> -->
        </div>

        <el-divider />

        <div class="profile-details">
          <div class="detail-section">
            <h3>基本信息</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <span class="label">职业</span>
                <span class="value">{{ userProfile.occupation || '未知' }}</span>
              </div>
              <div class="detail-item">
                <span class="label">学历</span>
                <span class="value">{{ userProfile.education || '未知' }}</span>
              </div>
              <div class="detail-item">
                <span class="label">婚姻状况</span>
                <span class="value">{{ userProfile.maritalStatus || '未知' }}</span>
              </div>
              <div class="detail-item">
                <span class="label">子女情况</span>
                <span class="value">{{ userProfile.boyCount }} 男孩 {{ userProfile.girlCount }} 女孩</span>
              </div>
              <div class="detail-item">
                <span class="label">收入范围</span>
                <span class="value">{{ formattedIncome }}</span>
              </div>
              <div class="detail-item">
                <span class="label">体重</span>
                <span class="value">{{ userProfile.weight ? userProfile.weight + 'kg' : '未知' }}</span>
              </div>
              <div class="detail-item">
                <span class="label">宗教信仰</span>
                <span class="value">{{ userProfile.religion || '未知' }}</span>
              </div>
              <div class="detail-item">
                <span class="label">实名认证</span>
                <span class="value">
                  <el-tag :type="userProfile.isVerified==1 ? 'success' : 'info'" size="small">
                    {{ userProfile.isVerified==1 ? '已认证' : '未认证' }}
                  </el-tag>
                </span>
              </div>
              <div class="detail-item">
                <span class="label">VIP等级</span>
                <span class="value">
                  <el-tag type="warning" size="small" v-if="userProfile.vipLevel > 0">
                    VIP {{ userProfile.vipLevel }}
                  </el-tag>
                  <span v-else>普通用户</span>
                </span>
              </div>
            </div>
          </div>

          <div class="detail-section" v-if="userProfile.tags && userProfile.tags.length">
            <h3>个性标签</h3>
            <div class="tags-list">
              <el-tag v-for="tag in userProfile.tags" :key="tag" class="tag-item">
                {{ tag }}
              </el-tag>
            </div>
          </div>

          <div class="detail-section">
            <h3>地理位置</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <span class="label">当前所在地</span>
                <span class="value">
                  {{ [userProfile.country, userProfile.province, userProfile.city, userProfile.district].filter(Boolean).join(' ') || '未知' }}
                </span>
              </div>
              <div class="detail-item">
                <span class="label">家乡</span>
                <span class="value">
                  {{ [userProfile.homeCountry, userProfile.homeProvince, userProfile.homeCity, userProfile.homeDistrict].filter(Boolean).join(' ') || '未知' }}
                </span>
              </div>
            </div>
          </div>

          <div class="detail-section" v-if="userProfile.hobbies && userProfile.hobbies.length">
            <h3>兴趣爱好</h3>
            <div class="hobbies-list">
              <el-tag v-for="hobby in userProfile.hobbies" :key="hobby" class="hobby-tag">
                {{ hobby }}
              </el-tag>
            </div>
          </div>

          <div class="detail-section" v-if="userProfile.introduction">
            <h3>自我介绍</h3>
            <p class="introduction">{{ userProfile.introduction }}</p>
          </div>

          <div class="detail-section" v-if="userProfile.photos && userProfile.photos.length">
            <h3>相册</h3>
            <div class="photo-grid">
              <el-image 
                v-for="(photo, index) in userProfile.photos" 
                :key="index"
                :src="photo"
                fit="cover"
                class="photo-item"
                :preview-src-list="userProfile.photos"
              >
                <template #error>
                  <div class="image-placeholder">
                    <el-icon><Picture /></el-icon>
                  </div>
                </template>
              </el-image>
            </div>
          </div>
        </div>

        <div class="profile-actions">
          <el-button type="primary" @click="startChat">开始聊天</el-button>
          <el-button type="danger" @click="likeUser">
            <el-icon><Star /></el-icon>
            喜欢
          </el-button>
        </div>
      </div>
      <div v-else-if="unlockPrompt" class="no-profile">
        <el-empty description="查看资料需要扣除10分，请在弹窗中确认" />
      </div>
      <div v-else-if="!loading" class="no-profile">
        <el-empty description="未找到用户资料" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Location, Star, Picture } from '@element-plus/icons-vue';
import { resolveProfilePhotoUrl, mapPhotoListToUrls } from '@/utils/photoUpload';
import {
  consumeProfileUnlockReminded,
  PROFILE_UNLOCK_NEED_CONFIRM,
  PROFILE_UNLOCK_CONFIRM_MESSAGE,
} from '@/utils/profileUnlock';

const route = useRoute();
const loading = ref(false);
const userProfile = ref(null);
const unlockPrompt = ref(false);
let loadSeq = 0;

const calculateAge = (birthday) => {
  if (!birthday) return null;
  
  // Convert integer YYYYMMDD to string and pad with leading zeros if needed
  const birthdayStr = birthday.toString().padStart(8, '0');
  
  // Parse YYYYMMDD format
  const year = parseInt(birthdayStr.substring(0, 4));
  const month = parseInt(birthdayStr.substring(4, 6)) - 1; // JavaScript months are 0-based
  const day = parseInt(birthdayStr.substring(6, 8));
  
  const birthDate = new Date(year, month, day);
  const today = new Date();
  
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age;
};

const userAge = computed(() => {
  if (!userProfile.value?.birthday) return null;
  return calculateAge(userProfile.value.birthday);
});

const formattedIncome = computed(() => {
  if (!userProfile.value?.income) return '未知';
  const incomeMap = {
    '0': '无收入',
    '5': '5k以下',
    '10': '5k-10k',
    '20': '10k-20k',
    '30': '20k-30k',
    '50': '30k-50k',
    '100': '50k-100k',
    '200': '100k-200k',
    '500': '200k-500k',
    '1000': '500k以上'
  };
  return incomeMap[userProfile.value.income] || '未知';
});

const applyProfile = (p) => {
  userProfile.value = {
    ...p,
    avatar: resolveProfilePhotoUrl(p.avatar, p.photo),
    photo: resolveProfilePhotoUrl(p.photo, p.avatar),
    photos: mapPhotoListToUrls(p.photos)
  };
};

const requestProfile = async (uuid, confirmed) => {
  const token = localStorage.getItem('jwt_token');
  const response = await fetch('/api/v1/user/profile/get', {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      uuid,
      confirmed
    })
  });
  return response.json();
};

const handleProfileResponse = (data) => {
  if (data.code === 200) {
    applyProfile(data.data);
    return true;
  }
  ElMessage.error(data.message || '获取用户资料失败');
  userProfile.value = null;
  return false;
};

const loadUserProfile = async () => {
  const uuid = route.params.id;
  const seq = ++loadSeq;
  userProfile.value = null;
  unlockPrompt.value = false;
  if (!uuid) return;

  const own = localStorage.getItem('uuid') === uuid;
  const alreadyReminded = consumeProfileUnlockReminded(uuid);

  const fetchConfirmed = async () => {
    loading.value = true;
    try {
      const data = await requestProfile(uuid, true);
      if (seq !== loadSeq) return;
      handleProfileResponse(data);
    } catch (error) {
      if (seq !== loadSeq) return;
      console.error('获取用户资料失败:', error);
      ElMessage.error('获取用户资料失败');
    } finally {
      if (seq === loadSeq) loading.value = false;
    }
  };

  if (own || alreadyReminded) {
    await fetchConfirmed();
    return;
  }

  loading.value = true;
  try {
    const data = await requestProfile(uuid, false);
    if (seq !== loadSeq) return;
    if (data.code === 200) {
      applyProfile(data.data);
      return;
    }
    if (data.code !== PROFILE_UNLOCK_NEED_CONFIRM) {
      handleProfileResponse(data);
      return;
    }
    unlockPrompt.value = true;
  } catch (error) {
    if (seq !== loadSeq) return;
    console.error('获取用户资料失败:', error);
    ElMessage.error('获取用户资料失败');
    return;
  } finally {
    if (seq === loadSeq) loading.value = false;
  }

  try {
    await ElMessageBox.confirm(
      PROFILE_UNLOCK_CONFIRM_MESSAGE,
      '提示',
      {
        confirmButtonText: '继续查看',
        cancelButtonText: '取消',
        type: 'warning'
      }
    );
  } catch {
    return;
  } finally {
    if (seq === loadSeq) unlockPrompt.value = false;
  }
  if (seq !== loadSeq) return;
  await fetchConfirmed();
};

const startChat = () => {
  ElMessage.info('私信功能暂未开放');
};

const likeUser = async () => {
  try {
    const token = localStorage.getItem('jwt_token');
    const response = await fetch('/api/v1/user/like', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        //targetUserId: parseInt(route.params.id),
        targetUuid: route.params.id,
        likeLevel: 1
      })
    });

    const data = await response.json();
    if (data.code === 200) {
      ElMessage.success('已添加到喜欢列表');
    } else {
      ElMessage.error(data.message || '操作失败');
    }
  } catch (error) {
    console.error('喜欢用户失败:', error);
    ElMessage.error('操作失败');
  }
};

watch(() => route.params.id, () => {
  loadUserProfile();
}, { immediate: true });
</script>

<style scoped>
.profile-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.profile-container {
  max-width: 1000px;
  margin: 0 auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 30px;
}

.profile-header {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
}

.profile-avatar {
  flex-shrink: 0;
}

.profile-basic-info {
  flex-grow: 1;
}

.profile-basic-info h1 {
  margin: 0 0 16px 0;
  font-size: 24px;
  color: #303133;
}

.profile-tags {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.profile-location {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #606266;
  font-size: 14px;
}

.profile-age {
  margin-top: 12px;
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.age-number {
  font-size: 32px;
  font-weight: bold;
  color: #409EFF;
}

.age-label {
  font-size: 16px;
  color: #606266;
}

.profile-main-photo {
  flex-shrink: 0;
  width: 200px;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.main-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.detail-section {
  margin-bottom: 30px;
}

.detail-section h3 {
  margin: 0 0 16px 0;
  font-size: 18px;
  color: #303133;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-item .label {
  font-size: 14px;
  color: #909399;
}

.detail-item .value {
  font-size: 16px;
  color: #303133;
}

.hobbies-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.hobby-tag {
  margin-right: 8px;
  margin-bottom: 8px;
}

.introduction {
  font-size: 16px;
  line-height: 1.6;
  color: #606266;
  white-space: pre-wrap;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.photo-item {
  width: 100%;
  height: 200px;
  border-radius: 4px;
  overflow: hidden;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  color: #909399;
  font-size: 30px;
}

.profile-actions {
  display: flex;
  gap: 16px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.no-profile {
  padding: 40px 0;
}

.tags-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-item {
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>